"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dossena": {
    "fa88e0e6": [{
      "hkey": "24ba6dac",
      "slug": "dossena",
      "name": "Dossena",
      "primary": true,
      "skipSearch": false
    }],
    "adelvais": [{
      "hkey": "24ba6dac",
      "slug": "dossena",
      "name": "Dossena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a5d13c4d": [{
      "hkey": "24ba6dac",
      "slug": "dossena",
      "name": "Dossena",
      "primary": true,
      "skipSearch": false
    }],
    "colle": [{
      "hkey": "24ba6dac",
      "slug": "dossena",
      "name": "Dossena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "239990c3": [{
      "hkey": "1741da64",
      "slug": "gromasera-lago-poggio-al-sole",
      "name": "Gromasera-Lago-Poggio al sole",
      "primary": true,
      "skipSearch": false
    }],
    "lago": [{
      "hkey": "1741da64",
      "slug": "gromasera-lago-poggio-al-sole",
      "name": "Gromasera-Lago-Poggio al sole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bc750407": [{
      "hkey": "24ba6dac",
      "slug": "dossena",
      "name": "Dossena",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "24ba6dac",
      "slug": "dossena",
      "name": "Dossena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dae53a05": [{
      "hkey": "1741da64",
      "slug": "gromasera-lago-poggio-al-sole",
      "name": "Gromasera-Lago-Poggio al sole",
      "primary": true,
      "skipSearch": false
    }],
    "gromasera": [{
      "hkey": "1741da64",
      "slug": "gromasera-lago-poggio-al-sole",
      "name": "Gromasera-Lago-Poggio al sole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "dossena"
    }]
  }
};
exports["default"] = _default;